import { Box, Button, HStack, Heading } from "@chakra-ui/react";
import PageHeader from "components/text/PageHeader";
import { prettyPrintCodeName } from "utils/text-utils";

/**
 * Wrapper for a step in a wizard. Provides a header and next/previous buttons.
 * Place the forms (or other content) in as the child element (and manage what to show via stepIndex).
 * Use-case: to help with consistent styling of wizard steps.
 *
 */
export default function WizardStepWrapper({
  children,
  nextText = "Next",
  previousText = "Previous",
  gotoNext,
  gotoPrevious,
  stepIndex,
  steps,
  superTitle,
  title,
  subTitle,
  nextDisabled,
}) {
  let displayTitle = title;
  if (displayTitle === undefined || displayTitle === null) {
    // false is allowed for no title
    displayTitle = prettyPrintCodeName(steps[stepIndex]);
  }
  return (
    <Box display="flex" flexDirection="column" h="100%">
      {displayTitle || superTitle || subTitle ? (
        <PageHeader superTitle={superTitle} title={displayTitle} subTitle={subTitle} />
      ) : null}
      {children}
      <Box flexGrow={1} />
      <HStack w="100%" justify="space-between" mt={4}>
        {stepIndex === 0 || !gotoPrevious ? (
          <div />
        ) : (
          <Button variant="secondary" onClick={gotoPrevious}>
            {previousText}
          </Button>
        )}

        {stepIndex === steps.length - 1 || !gotoNext ? (
          <div />
        ) : (
          <Button
            variant="primary"
            onClick={gotoNext}
            isDisabled={nextDisabled}
            title={typeof nextDisabled === "string" ? nextDisabled : undefined}
          >
            {nextText}
          </Button>
        )}
      </HStack>
    </Box>
  );
}
